<template>
  <select
    id="select-sm"
    v-model="selected"
    class="form-select form-select-sm px-3 border rounded-md bg-white dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 py-2 focus: outline-none"
    aria-label="Accent"
  >
    <option v-for="option in options" :key="option.id" :value="option.value">
      {{ $t(option.text) }}
    </option>
  </select>
</template>

<script setup lang="ts">
defineProps<{
  options: { id: number; value: string; text: string }[];
}>();

const selected = defineModel<string>("voice");
</script>
